import { render } from "./TimelineList.vue?vue&type=template&id=21a1b822&scoped=true"
import script from "./TimelineList.vue?vue&type=script&lang=js"
export * from "./TimelineList.vue?vue&type=script&lang=js"

import "./TimelineList.vue?vue&type=style&index=0&id=21a1b822&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a1b822"]])

export default __exports__